<template lang="pug">
a(
  v-if="instance=='mfar'"
  target="_blank"
  :href="getCauUrl()"
)
  | {{ $t('components.cau_link.tpl.cau') }}
  i.fa.fa-external-link.ml-1(v-if="showIcon")
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState } = createNamespacedHelpers('login');

export default {
  props: {
    showIcon: {
      default: true,
      required: false,
      type: Boolean,
    },
  },
  computed: {
    ...mapState([
      'instance',
    ]),
  },
  methods: {
    getCauUrl() {
      const URL = encodeURIComponent(window.location.href);

      return `/cau/#/?&url=${URL}`;
    },
  },
};
</script>
